import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { adminGet } from "@/lib/adminApi";
import ClientFiche from "@/components/admin/ClientFiche";

export default function PatientelePage() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [detail, setDetail] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    adminGet(`/users/${userId}`).then(setDetail).catch(() => setError(true));
  }, [userId]);

  return (
    <div data-testid="patientele-page">
      <button type="button" className="rav-text-link" data-testid="patientele-back" onClick={() => navigate("/admin")}>
        <ArrowLeft size={15} strokeWidth={1.6} /> Retour à la patientèle
      </button>
      {error && <p className="rav-page-sub">Cette fiche est introuvable.</p>}
      {!detail && !error && <p className="rav-page-sub">Chargement de la fiche…</p>}
      {detail && <ClientFiche detail={detail} onClose={() => navigate("/admin")} />}
    </div>
  );
}
